<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>

      <div class="row">
        <system-sidebar></system-sidebar>

        <div class="col-xl-9">
          <div class="card">
            <div class="card-body">
              <div
                class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3"
              >
                <div class="d-flex align-items-center">
                  <h4 class="mb-0 me-2">Email Templates</h4>
                  <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                </div>

                <div class="d-flex align-items-center">
                  <input
                    v-model="search"
                    type="text"
                    class="form-control form-control-sm me-2"
                    placeholder="Search by name or key..."
                    style="max-width: 220px"
                    @keyup.enter="loadTemplates"
                  />
                  <button
                    class="btn btn-white btn-sm me-2"
                    type="button"
                    @click="loadTemplates"
                  >
                    <i class="ti ti-refresh me-1"></i>Reload
                  </button>
                  <button
                    class="btn btn-primary"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#template-modal"
                    @click="openCreate"
                  >
                    <i class="ti ti-circle-plus me-2"></i>Add Template
                  </button>
                </div>
              </div>

              <!-- Templates grid -->
              <div>
                <div
                  v-if="templates.length === 0 && !loading"
                  class="alert alert-info"
                >
                  No email templates found. Click
                  <strong>Add Template</strong> to create one.
                </div>

                <div class="row">
                  <div class="col-md-4" v-for="tpl in templates" :key="tpl.id">
                    <div class="mb-3">
                      <div class="card h-100">
                        <div
                          class="card-body p-3 d-flex flex-column justify-content-between"
                        >
                          <div class="mb-2">
                            <div
                              class="d-flex align-items-start justify-content-between"
                            >
                              <div>
                                <h6 class="mb-1">
                                  {{ tpl.name }}
                                  <span
                                    v-if="!tpl.is_active"
                                    class="badge bg-light text-muted ms-1"
                                    >Inactive</span
                                  >
                                </h6>
                                <small class="text-muted d-block">
                                  Key: {{ tpl.key }}
                                </small>
                                <small
                                  v-if="tpl.category"
                                  class="badge bg-soft-primary text-primary mt-1"
                                >
                                  {{ tpl.category }}
                                </small>
                              </div>

                              <div class="d-flex align-items-center ms-2">
                                <button
                                  type="button"
                                  class="btn btn-sm btn-icon me-1"
                                  data-bs-toggle="tooltip"
                                  title="Edit"
                                  @click="openEdit(tpl)"
                                >
                                  <i class="ti ti-edit"></i>
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-icon"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete-template-modal"
                                  @click="openDelete(tpl)"
                                >
                                  <i class="ti ti-trash"></i>
                                </button>
                              </div>
                            </div>
                            <p
                              class="mt-2 mb-0 text-truncate"
                              style="max-width: 100%"
                            >
                              {{ tpl.subject }}
                            </p>
                          </div>

                          <!-- Quick info on common placeholders -->
                          <div
                            v-if="placeholdersFor(tpl.key).length"
                            class="mt-2"
                          >
                            <small class="text-muted d-block mb-1"
                              >Placeholders:</small
                            >
                            <div class="d-flex flex-wrap gap-1">
                              <span
                                v-for="ph in placeholdersFor(tpl.key)"
                                :key="ph"
                                class="badge bg-light text-muted"
                              >
                                {{ ph }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /col -->
                </div>
                <!-- /row -->
              </div>

              <!-- Footer actions (here just a refresh to keep layout consistent) -->
              <div
                class="d-flex align-items-center justify-content-end border-top pt-3 mt-2"
              >
                <button
                  type="button"
                  class="btn btn-outline-light border me-3"
                  :disabled="loading"
                  @click="loadTemplates"
                >
                  Refresh
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>

  <!-- Create / Edit Template Modal (UPGRADED UI ONLY) -->
  <div class="modal fade dq-tpl-modal" id="template-modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-xl dq-tpl-dialog">
      <div class="modal-content dq-modal-content">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-indigo">
              <i class="ti ti-mail-fast"></i>
            </div>
            <div>
              <h5 class="modal-title dq-title mb-0">
                {{ isEdit ? "Edit Email Template" : "Add Email Template" }}
              </h5>
              <div class="dq-subtitle">
                Create reusable templates with placeholders and HTML content.
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitTemplate">
          <!-- Body (scrolls) -->
          <div class="modal-body dq-modal-body">
            <div class="row g-3">
              <!-- Template Name -->
              <div class="col-md-6">
                <label class="form-label dq-label">Template Name</label>
                <input
                  type="text"
                  class="form-control dq-input"
                  v-model="form.name"
                  placeholder="e.g. Leave Request Submitted"
                  required
                />
              </div>

              <!-- Key -->
              <div class="col-md-6">
                <label class="form-label dq-label"
                  >Key (unique identifier)</label
                >
                <input
                  type="text"
                  class="form-control dq-input"
                  v-model="form.key"
                  :readonly="isEdit"
                  placeholder="e.g. leave_request_submitted"
                  required
                />
                <div class="dq-help">
                  Example: <code>employee_welcome</code>,
                  <code>leave_request_submitted</code>
                </div>
              </div>

              <!-- Category -->
              <div class="col-md-6">
                <label class="form-label dq-label">Category (module)</label>
                <input
                  type="text"
                  class="form-control dq-input"
                  v-model="form.category"
                  placeholder="e.g. employee, leave, payroll"
                />
              </div>

              <!-- Active -->
              <div class="col-md-6">
                <label class="form-label dq-label">Status</label>
                <div class="dq-switch">
                  <div class="form-check form-switch m-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.is_active"
                      id="tplActive"
                    />
                    <label class="form-check-label" for="tplActive">
                      {{ form.is_active ? "Enabled" : "Disabled" }}
                    </label>
                  </div>
                  <span
                    class="dq-pill"
                    :class="form.is_active ? 'dq-pill-live' : 'dq-pill-muted'"
                  >
                    <i
                      :class="form.is_active ? 'ti ti-check' : 'ti ti-circle-x'"
                    ></i>
                    {{ form.is_active ? "Active" : "Inactive" }}
                  </span>
                </div>
              </div>

              <!-- Subject -->
              <div class="col-12">
                <label class="form-label dq-label">Subject</label>
                <input
                  type="text"
                  class="form-control dq-input"
                  v-model="form.subject"
                  placeholder="e.g. Your leave request has been submitted"
                  required
                />
              </div>

              <!-- Placeholders hint -->
              <div class="col-12" v-if="placeholdersFor(form.key).length">
                <div class="dq-callout">
                  <div class="dq-callout-head">
                    <i class="ti ti-braces"></i>
                    <div>
                      <div class="dq-callout-title">Available placeholders</div>
                      <div class="dq-callout-sub">
                        Use these in subject and body (HTML or plain text).
                      </div>
                    </div>
                  </div>

                  <div class="dq-ph">
                    <button
                      v-for="ph in placeholdersFor(form.key)"
                      :key="ph"
                      type="button"
                      class="dq-ph-chip"
                      @click="navigator.clipboard?.writeText(ph)"
                      title="Click to copy"
                    >
                      {{ ph }}
                      <i class="ti ti-copy ms-1"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- HTML Body -->
              <div class="col-12">
                <label class="form-label dq-label">HTML Body</label>
                <textarea
                  class="form-control dq-input dq-textarea"
                  rows="10"
                  v-model="form.body_html"
                  placeholder="<h1>Hello {{employee_name}}</h1> ..."
                ></textarea>
                <div class="dq-help">
                  You can include basic HTML and placeholders like
                  <code>{{ "{" }}{employee_name}{'}' }}</code>.
                </div>
              </div>

              <!-- Plain text -->
              <div class="col-12">
                <label class="form-label dq-label"
                  >Plain Text Body (optional)</label
                >
                <textarea
                  class="form-control dq-input dq-textarea"
                  rows="5"
                  v-model="form.body_text"
                  placeholder="Hello {{employee_name}}, ..."
                ></textarea>
              </div>
            </div>
          </div>

          <!-- Sticky Footer -->
          <div class="modal-footer dq-modal-footer">
            <button
              type="button"
              class="btn btn-light dq-btn dq-btn-muted"
              data-bs-dismiss="modal"
              :disabled="saving"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="btn btn-primary dq-btn dq-btn-primary"
              :disabled="saving"
            >
              <span
                v-if="saving"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              {{ isEdit ? "Update Template" : "Save Template" }}
              <i class="ti ti-arrow-right ms-2"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Template Modal (UPGRADED UI ONLY) -->
  <div class="modal fade dq-tpl-modal" id="delete-template-modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered dq-del-dialog">
      <div class="modal-content dq-modal-content">
        <div class="modal-header dq-modal-header dq-danger-head">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-red">
              <i class="ti ti-trash"></i>
            </div>
            <div>
              <h5 class="modal-title dq-title mb-0">Delete Template</h5>
              <div class="dq-subtitle">This action cannot be undone.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body dq-modal-body">
          <div class="dq-danger">
            <i class="ti ti-alert-octagon"></i>
            <div>
              <div class="dq-danger-title">You’re about to delete:</div>
              <div class="dq-danger-name">
                {{ deleteTarget?.name || "-" }}
                <span class="dq-pill dq-pill-muted ms-2">
                  <i class="ti ti-key"></i> {{ deleteTarget?.key || "-" }}
                </span>
              </div>
              <div class="dq-danger-sub">
                If this template is used by automations, emails may stop
                sending.
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer dq-modal-footer">
          <button
            type="button"
            class="btn btn-light dq-btn dq-btn-muted"
            data-bs-dismiss="modal"
            :disabled="deleting"
          >
            Cancel
          </button>

          <button
            type="button"
            class="btn btn-danger dq-btn dq-btn-danger"
            :disabled="deleting"
            @click="confirmDelete"
          >
            <span
              v-if="deleting"
              class="spinner-border spinner-border-sm me-2"
            ></span>
            Delete Template
            <i class="ti ti-trash ms-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import * as bootstrap from "bootstrap";
import { toast } from "@/utils/toast";
import emailTemplateService from "@/services/emailTemplateService";

const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const loading = ref(false);
const saving = ref(false);
const deleting = ref(false);

const templates = ref([]);
const search = ref("");

const isEdit = ref(false);
const form = reactive({
  id: null,
  key: "",
  name: "",
  category: "",
  subject: "",
  body_html: "",
  body_text: "",
  is_active: true,
});

const deleteTarget = ref(null);

// Known placeholders for core events
const placeholderMap = {
  employee_welcome: [
    "{{employee_name}}",
    "{{company_name}}",
    "{{email}}",
    "{{set_password_url}}",
    "{{reset_url}}",
    "{{password}}",
    "{{portal_url}}",
  ],
  leave_request_submitted: [
    "{{employee_name}}",
    "{{company_name}}",
    "{{leave_type}}",
    "{{from_date}}",
    "{{to_date}}",
    "{{days}}",
    "{{status}}",
  ],
  leave_request_approved: [
    "{{employee_name}}",
    "{{company_name}}",
    "{{leave_type}}",
    "{{from_date}}",
    "{{to_date}}",
    "{{approved_by}}",
  ],
  leave_request_declined: [
    "{{employee_name}}",
    "{{company_name}}",
    "{{leave_type}}",
    "{{from_date}}",
    "{{to_date}}",
    "{{approved_by}}",
  ],
};

function placeholdersFor(key) {
  if (!key) return [];
  return placeholderMap[key] || [];
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function loadTemplates() {
  loading.value = true;
  try {
    const res = await emailTemplateService.getAll({
      q: search.value || undefined,
    });
    templates.value = Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Failed to load email templates. Please try again.";
    toast(msg, "error");
  } finally {
    loading.value = false;
  }
}

function resetForm() {
  form.id = null;
  form.key = "";
  form.name = "";
  form.category = "";
  form.subject = "";
  form.body_html = "";
  form.body_text = "";
  form.is_active = true;
}

function openCreate() {
  isEdit.value = false;
  resetForm();
}

function openEdit(tpl) {
  isEdit.value = true;
  form.id = tpl.id;
  form.key = tpl.key;
  form.name = tpl.name;
  form.category = tpl.category || "";
  form.subject = tpl.subject || "";
  form.body_html = tpl.body_html || "";
  form.body_text = tpl.body_text || "";
  form.is_active = !!tpl.is_active;

  const el = document.getElementById("template-modal");
  if (el) {
    const m = new bootstrap.Modal(el);
    m.show();
  }
}

async function submitTemplate() {
  if (!form.name || !form.key || !form.subject) {
    toast("Name, key and subject are required.", "error");
    return;
  }

  const payload = {
    key: form.key,
    name: form.name,
    category: form.category || null,
    subject: form.subject,
    body_html: form.body_html || null,
    body_text: form.body_text || null,
    is_active: !!form.is_active,
  };

  saving.value = true;
  try {
    if (isEdit.value && form.id) {
      await emailTemplateService.update(form.id, payload);
      toast("Email template updated successfully");
    } else {
      await emailTemplateService.create(payload);
      toast("Email template created successfully");
    }

    await loadTemplates();
    closeModal("template-modal");
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Failed to save email template. Please try again.";
    toast(msg, "error");
  } finally {
    saving.value = false;
  }
}

function openDelete(tpl) {
  deleteTarget.value = tpl;
}

async function confirmDelete() {
  if (!deleteTarget.value) return;
  deleting.value = true;
  try {
    await emailTemplateService.delete(deleteTarget.value.id);
    toast("Email template deleted successfully");
    await loadTemplates();
    closeModal("delete-template-modal");
    deleteTarget.value = null;
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Failed to delete email template. Please try again.";
    toast(msg, "error");
  } finally {
    deleting.value = false;
  }
}

function closeModal(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const instance = bootstrap.Modal.getInstance(el) || new bootstrap.Modal(el);
  instance.hide();

  // Safety: clean leftover backdrop & body state
  window.setTimeout(() => {
    document
      .querySelectorAll(".modal-backdrop")
      .forEach((bd) => bd.parentNode && bd.parentNode.removeChild(bd));
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
  }, 200);
}

onMounted(() => {
  loadTemplates();
});
</script>

<style scoped>
/* Bigger + world-class */
.dq-tpl-dialog {
  max-width: 1080px; /* ✅ wider than modal-lg */
}
.dq-del-dialog {
  max-width: 620px;
}
@media (max-width: 992px) {
  .dq-tpl-dialog,
  .dq-del-dialog {
    max-width: 96%;
  }
}

/* Shell */
.dq-modal-content {
  border-radius: 22px;
  border: none;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08),
    0 40px 90px rgba(15, 23, 42, 0.14);
}
.dq-modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.14), #fff);
}
.dq-danger-head {
  background: linear-gradient(180deg, rgba(239, 68, 68, 0.12), #fff);
}
.dq-modal-body {
  padding: 18px 22px;
  max-height: calc(100vh - 230px); /* ✅ fixes scrolling */
  overflow: auto;
}
.dq-modal-footer {
  padding: 14px 22px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

/* Header title */
.dq-titlewrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dq-title {
  font-weight: 950;
  letter-spacing: -0.35px;
}
.dq-subtitle {
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}
.dq-close {
  opacity: 0.9;
}
.dq-close:hover {
  opacity: 1;
}

/* Hero icons */
.dq-hero {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.dq-hero-indigo {
  background: rgba(99, 102, 241, 0.16);
  color: rgb(79, 70, 229);
}
.dq-hero-red {
  background: rgba(239, 68, 68, 0.14);
  color: rgb(220, 38, 38);
}

/* Inputs */
.dq-label {
  font-size: 0.82rem;
  font-weight: 900;
}
.dq-input {
  border-radius: 14px;
  padding: 10px 12px;
  transition: all 0.15s ease;
}
.dq-input:focus {
  border-color: rgba(99, 102, 241, 0.55);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.14);
}
.dq-textarea {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  font-size: 0.9rem;
}

/* Help text */
.dq-help {
  margin-top: 6px;
  font-size: 0.78rem;
  color: rgba(15, 23, 42, 0.55);
}

/* Active switch row */
.dq-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 12px;
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(15, 23, 42, 0.02);
}

/* Placeholder callout */
.dq-callout {
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(99, 102, 241, 0.06);
  border-radius: 18px;
  padding: 12px 14px;
}
.dq-callout-head {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 10px;
  color: rgba(15, 23, 42, 0.85);
}
.dq-callout-title {
  font-weight: 950;
  letter-spacing: -0.2px;
}
.dq-callout-sub {
  font-size: 0.8rem;
  color: rgba(15, 23, 42, 0.6);
}
.dq-ph {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.dq-ph-chip {
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #fff;
  color: rgba(15, 23, 42, 0.78);
  border-radius: 999px;
  padding: 7px 12px;
  font-weight: 900;
  font-size: 0.78rem;
  cursor: pointer;
}
.dq-ph-chip:hover {
  background: rgba(15, 23, 42, 0.03);
}

/* Pills */
.dq-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 999px;
  font-weight: 950;
  font-size: 0.78rem;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
}
.dq-pill-live {
  background: rgba(34, 197, 94, 0.1);
  color: rgb(22, 163, 74);
  border-color: rgba(34, 197, 94, 0.18);
}
.dq-pill-muted {
  background: rgba(15, 23, 42, 0.05);
  color: rgba(15, 23, 42, 0.75);
}

/* Delete warning */
.dq-danger {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 14px;
  border-radius: 18px;
  border: 1px solid rgba(239, 68, 68, 0.14);
  background: rgba(239, 68, 68, 0.08);
}
.dq-danger i {
  font-size: 18px;
  color: rgb(220, 38, 38);
  margin-top: 2px;
}
.dq-danger-title {
  font-weight: 950;
}
.dq-danger-name {
  font-weight: 950;
  margin-top: 4px;
}
.dq-danger-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.7);
}

/* Buttons */
.dq-btn {
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 900;
}
.dq-btn-primary {
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.1);
}
.dq-btn-danger {
  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.12);
}
</style>


